import * as React from 'react'
import { ReactElement } from 'react'
import {
    ActionButton,
    CheckboxVisibility,
    DetailsList,
    DetailsListLayoutMode,
    DetailsRow,
    DialogFooter,
    IColumn,
    SelectionMode,
    Stack,
} from '@fluentui/react'
import LegacyBaseDialog from '../../../components/Dialog/LegacyBaseDialog'
import { EntityType, SearchResult } from './EntityField'
import { useTranslation } from 'react-i18next'

type Props = {
    items: SearchResult[]
    externalType: EntityType
    onDismiss: () => void
    onSelect: (item: SearchResult) => void
}

const getColumns = (translate: (key: string) => string): IColumn[] => [
    {
        key: 'id',
        fieldName: 'id',
        name: translate('base.table.header.id'),
        minWidth: 120,
        maxWidth: 120,
        isCollapsible: true,
    },
    {
        key: 'code',
        fieldName: 'code',
        name: translate('base.table.header.number'),
        minWidth: 90,
        maxWidth: 90,
        isCollapsible: false,
    },
    {
        key: 'name',
        fieldName: 'name',
        name: translate('base.table.header.code'),
        minWidth: 240,
        isResizable: true,
    },
]

export default function EntitySearchResultDialog(props: Props): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <LegacyBaseDialog
            hidden={!props.items}
            title={translate(`accounting.dimensions.search.${props.externalType.toString().toLowerCase().replaceAll(/[-_]/g, '')}`)}
            onDismiss={props.onDismiss}
        >
            <DetailsList
                columns={getColumns(translate)}
                onItemInvoked={item => props.onSelect(item)}
                items={props.items || []}
                onRenderRow={rowProps => (
                    <Stack onClick={() => props.onSelect(rowProps.item)}>
                        <DetailsRow {...rowProps} styles={{ root: { cursor: 'pointer' } }} />
                    </Stack>
                )}
                compact
                checkboxVisibility={CheckboxVisibility.hidden}
                selectionMode={SelectionMode.single}
                layoutMode={DetailsListLayoutMode.justified}
            />
            <DialogFooter>
                <ActionButton text={translate('action.cancel')} onClick={props.onDismiss} />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
